import { useEffect, useMemo } from 'react';

import useFilesInDocumentStore from '@/components/elements/DropScan/useFilesInDocument.store';
import useFilesByDocumentIdQuery from '@/modules/employee/TransactionDetails/useFilesByDocumentId.query';

import { LMN_UPLOAD_STORE_KEY } from '../LettersOfMedicalNecessity.types';
import useGetLmnItemQuery from '../queries/useGetLmnItem.query';

interface Props {
  id?: string;
}

export const useViewLmnItem = ({ id }: Props) => {
  const { isLoading: isLmnLoading, lmnItem } = useGetLmnItemQuery({ id });
  const documentId = useMemo(() => lmnItem?.documentId, [lmnItem?.documentId]);
  const { files, isLoading: isFilesLoading } = useFilesByDocumentIdQuery(documentId);
  const { values, handleSetValues: setFilesDocument } = useFilesInDocumentStore(LMN_UPLOAD_STORE_KEY);

  useEffect(() => {
    if (documentId && files && !values.files?.length) {
      setFilesDocument({ documentId, files });
    }
  }, [documentId, files, setFilesDocument, values.files?.length]);
  return {
    lmnItem,
    lmnFiles: files,
    isLoading: isLmnLoading || isFilesLoading,
  };
};
export default useViewLmnItem;
